import type { CSSProperties } from 'react';
import ShortText from './ShortText';
import { questionStyle } from './Survey.css';

interface Props {
  email: string;
}

const EmailInput = ({ email }: Props) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        textAlign: 'var(--text-align)' as CSSProperties['textAlign'],
      }}
    >
      <label className={questionStyle} htmlFor="email">
        Email
        <span style={{ color: 'var(--question-required-color)' }}>&#42;</span>
      </label>
      <div>
        <ShortText name="email" required type="email" isHidden={Boolean(email)} />
      </div>
    </div>
  );
};

export default EmailInput;
